<template>
  <TextFieldTimeout v-show="searchable"
                    v-model="searchterm"
                    dense
                    clearable
                    single-line
                    hide-details
                    :label="$t('servicesystem.common_objects.commonterms.filter_search')"
                    class="mx-2">
  </TextFieldTimeout>
</template>


<script>
import TextFieldTimeout from "@/components/Inputs/Parts/TextFieldTimeout.vue";

export default {
  name: "ListToolbar",
  model: {
    prop: "outputlist",
    event: "change",
  },
  props: {
    outputlist: Array,
    inputlist: Array,
    objectName: String,
    sortablefields: Array,
    filterablefields: Array,
  },
  components: {
    TextFieldTimeout,
  },
  mixins: [],

  data() {
    return {
      timestamp: null,
      refreshlimit: 100,
    };
  },

  mounted() {
    this.searchterm = "";
  },

  methods: {
    searchfilter() {
      var filtered = Object.assign([], this.inputlist);
      if (this.searchable && this.searchterm) {
        var stringarr = this.searchterm.replace(/\s?$/, "").split(" ");
        var regexarr = [];
        stringarr.forEach((element) => {
          regexarr.push(new RegExp("(" + element + ")", "gi"));
        });
        
        
        filtered = filtered.filter((item) => {
          return regexarr.every((reg) => {
            return item["MetaString"].match(reg);
          });
        });
      }
      return filtered;
    },

    repeaterBlock() {
      if (new Date() - this.timestamp < this.refreshlimit) {
        
        return true;
      } else {
        return false;
      }
    },

    splitIntoRegex(string) {
      if (string) {
        string = string.replace(/\s?$/, "");
        string = string.replaceAll(" ", "|");
        var regex = new RegExp("(" + string + ")", "gi");
        return regex;
      } else {
        return string;
      }
    },
  },

  computed: {
    searchfilteredlist() {
      return this.searchfilter();
    },

    searchable() {
      var searchablebool = this.inputlist.some((propperty) => propperty["MetaString"] != undefined);
      return searchablebool;
    },

    searchterm: {
      get: function () {
        return this.$store.state.filtersearchterm;
      },
      set: function (newValue) {
        this.$store.dispatch("updateFilterSearch", newValue);
      },
    },
  },

  watch: {
    searchfilteredlist: function (newval) {
      if (!this.repeaterBlock()) {
        
        this.timestamp = new Date();
        this.$emit("change", newval);
      }
    },
  },
};
</script>


<style lang='scss' scoped>
</style>